import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import LocalService from '../../../../../services/local-auth';
import SecretariaService from '../../../../../services/secretaria';



const Local = () => {
    const [nome, setNome] = useState("");
    const [endereco, setEndereco] = useState("");
    const [horarios, setHorarios] = useState("");
    const [telefone, setTelefone] = useState("");
    const [telefonePlantao, setTelefonePlantao] = useState("");
    const [responsavel, setResponsavel] = useState("");
    const [email, setEmail] = useState("");
    const [secretaria, setSecretaria] = useState("");
    const [descricao, setDescricao] = useState("");
    const [secretarias, setSecretarias] = useState([])
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    const montaSec = async () => {
        const secs = await SecretariaService.listar()
        setSecretarias(secs.data)
    }


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const loc = await LocalService.cadastro({
                nome: nome,
                endereco: endereco,
                horarios: horarios,
                telefone: telefone,
                telefonePlantao: telefonePlantao,
                email: email,
                secretaria: secretaria,
                responsavel: responsavel,
                descricao: descricao
            })
            if (loc.data["_id"]) {
                alert("Órgão cadastrado com sucesso!")
                setSucesso(true);
            }
            else {
                alert(loc.data["error"]);
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        montaSec()
    }, [])


    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setNome("");
        setEndereco("");
        setHorarios("");
        setTelefone("");
        setTelefonePlantao("");
        setEmail("");
        setSecretaria("");
        setResponsavel("");
        setDescricao("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                    <Col xs={12}>
                            <Form.Group className="mb-3" controlId="Processo">
                                <FloatingLabel
                                    label="Secretaria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Secretaria"
                                        name="secretaria"
                                        onChange={e => setSecretaria(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        {secretarias.map((sec) =>
                                            <option value={sec.nome}>{sec.nome}</option>
                                        )}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Nome do Local"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="endereco">
                                <FloatingLabel
                                    label="Endereço até o bairro"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="endereco"
                                        value={endereco}
                                        onChange={e => setEndereco(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="horarios">
                                <FloatingLabel
                                    label="Horários de Funcionamento"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="horarios"
                                        value={horarios}
                                        onChange={e => setHorarios(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="telefone">
                                <FloatingLabel
                                    label="Telefone de Atendimento (2554-XXXX)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="telefone"
                                        value={telefone}
                                        onChange={e => setTelefone(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="telefonePlantao">
                                <FloatingLabel
                                    label="Telefone do Plantão (2554-XXXX) / (99999-9999)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="telefonePlantao"
                                        value={telefonePlantao}
                                        onChange={e => setTelefonePlantao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="email">
                                <FloatingLabel
                                    label="E-mail"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="responsavel">
                                <FloatingLabel
                                    label="Responsável pelo local"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="responsavel"
                                        value={responsavel}
                                        onChange={e => setResponsavel(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="telefone">
                                <FloatingLabel
                                    label="Descrição dos Serviços Prestados"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        aria-rowcount={3}
                                        name="descricao"
                                        value={descricao}
                                        onChange={e => setDescricao(e.target.value)} 
                                        as="textarea"
                                        rows={5}
                                        />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/institucional/locais'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Órgão cadastrado com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/institucional/locais/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Pontos de Atendimento
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/institucional/locais'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Local;